<!-- Banner -->
<div class="govuk-cookie-banner noprint" data-nosnippet role="region" [attr.aria-label]="heading" *ngIf="showCookieBanner || showRejectedBanner || showAcceptedBanner">
  <div class="govuk-cookie-banner__message govuk-width-container" *ngIf="showCookieBanner">
    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">
        <h2 class="govuk-cookie-banner__heading govuk-heading-m">{{heading}}</h2>

        <div class="govuk-cookie-banner__content">
          <p class="govuk-body">We use some essential cookies to make this service work.</p>
          <p class="govuk-body">We'd also like to use analytics cookies so we can understand how you use the service and make improvements.</p>
        </div>
      </div>
    </div>

    <div class="govuk-button-group">
      <button value="accept" type="button" name="cookies" class="govuk-button theme-button" data-module="govuk-button" (click)="acceptCookies()">
        Accept analytics cookies
      </button>
      <button value="reject" type="button" name="cookies" class="govuk-button theme-button" data-module="govuk-button" (click)="rejectCookies()">
        Reject analytics cookies
      </button>
    </div>
  </div>

  <!-- Accepted -->
  <div class="govuk-cookie-banner__message govuk-width-container" role="alert" *ngIf="showAcceptedBanner">
    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">

        <div class="govuk-cookie-banner__content">
          <p class="govuk-body">You’ve accepted analytics cookies. You can <a class="govuk-link" [routerLink]="'/cookies'"  (click)="hideConfirmation()">change your cookie settings</a> at any time.</p>
        </div>
      </div>
    </div>

    <div class="govuk-button-group">
      <button class="govuk-button theme-button" data-module="govuk-button" (click)="hideConfirmation()">
        Hide this message
      </button>
    </div>
  </div>

  <!-- Rejected -->
  <div class="govuk-cookie-banner__message govuk-width-container" role="alert" *ngIf="showRejectedBanner">

    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">

        <div class="govuk-cookie-banner__content">
          <p class="govuk-body">You’ve rejected analytics cookies. You can <a class="govuk-link" [routerLink]="'/cookies'" (click)="hideConfirmation()">change your cookie settings</a> at any time.</p>
        </div>
      </div>
    </div>

    <div class="govuk-button-group">
      <button class="govuk-button theme-button" data-module="govuk-button" (click)="hideConfirmation()">
        Hide this message
      </button>
    </div>
  </div>
</div>
